/** @flow */

import {
  GetUserAccounts,
  GetUserAccountsSuccess,
  GetUserAccountsError,
  ExportUserAccountsSuccess,
  ExportUserAccountsError,
  ExportUserAccounts,
} from "@modules/service/constants/actions";
import initialState from "./state";
import type { UserAccountsState } from "./types";
import * as userAccountsReducers from "./reducers";
import { cloneObject } from "@utils/object";

export default (state: UserAccountsState = initialState, action: Object): UserAccountsState => {
  const act = {
    [GetUserAccounts]: userAccountsReducers.setLoading,
    [ExportUserAccounts]: userAccountsReducers.setLoading,
    [GetUserAccountsSuccess]: userAccountsReducers.onGetUserAccountsSuccess,
    [GetUserAccountsError]: userAccountsReducers.onGetUserAccountsError,
    [ExportUserAccountsSuccess]: userAccountsReducers.onExportUserAccountsSuccess,
    [ExportUserAccountsError]: userAccountsReducers.onExportUserAccountsError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
